import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

export const ConfigWrapper = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: ${token('space.150')};
    margin: ${token('space.050')};
`;

export const ViewWrapper = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: ${token('space.150')};
    
`;

export const JqlEditorWrapper = styled.div`
    div:has(> [id$='jql-editor-help-content']),
    div:has(> [aria-describedby$='syntax-help-description']) {
        display: none;
    }
`;

export const TableTreeWrapper = styled.div<{ forcedTableWidth: string }>`
    width: ${({ forcedTableWidth }) => forcedTableWidth};
    min-width: 100%;
    
`;

export const TableWrapper = styled.div`
    display: flex;
    flex-direction: column;
    overflow-x: auto;
    width: 100vw;
`;


